import * as THREE from "three";
import { GLTFLoader } from "three/addons/loaders/GLTFLoader.js";
import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader.js";

export type AssetPipelineConfig = {
  // Reserved for future KTX2 / compressed texture setup.
  basisTranscoderPath?: string;
};

export class AssetPipeline {
  private hdrLoader?: RGBELoader;
  private gltfLoader?: GLTFLoader;
  private readonly sceneCache = new Map<string, Promise<THREE.Group>>();

  constructor(
    private readonly renderer: THREE.WebGLRenderer,
    private readonly config: AssetPipelineConfig = {},
  ) {}

  createHDRLoader(): RGBELoader {
    void this.renderer;
    void this.config.basisTranscoderPath;
    this.hdrLoader ??= new RGBELoader();
    return this.hdrLoader;
  }

  createGLTFLoader(): GLTFLoader {
    void this.renderer;
    this.gltfLoader ??= new GLTFLoader();
    return this.gltfLoader;
  }

  async loadSceneTemplate(path: string): Promise<THREE.Group> {
    let promise = this.sceneCache.get(path);
    if (!promise) {
      promise = this.createGLTFLoader().loadAsync(path).then((gltf) => gltf.scene);
      this.sceneCache.set(path, promise);
    }
    return promise;
  }

  cloneSceneTemplate(src: THREE.Group): THREE.Group {
    const clone = src.clone(true) as THREE.Group;
    clone.traverse((obj) => {
      if (!(obj as THREE.Mesh).isMesh) return;
      const mesh = obj as THREE.Mesh;
      mesh.castShadow = true;
      mesh.receiveShadow = true;
      if (Array.isArray(mesh.material)) {
        mesh.material = mesh.material.map((material) => material.clone());
      } else {
        mesh.material = mesh.material.clone();
      }
    });
    return clone;
  }
}
